<template>
  <div>
    <h1 class="title">Dokument hochladen</h1>
    <h2 class="subtitle">Laden Sie hier Ihre PDF Dokumente hoch</h2>
    <br />
    <DocumentDragAndDrop
      @upload="handleFileUpload($event)"
      :uploadProgress="uploadProgress"
    />
    <br />
    <br />
    <h4 class="title is-size-4">Keine Dokumente zur Hand?</h4>
    <h4 class="subtitle is-size-5">
      Clicken Sie auf folgende Links für Beispiele
    </h4>
    <div class="content">
      <ul>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=betriebsanleitung+w%C3%A4rmeanlage+filetype%3Apdf"
            target="_blank"
            >Betriebsanleitung Wärmeanlage</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=brandschutznachweis+filetype%3Apdf"
            target="_blank"
            >Brandschutznachweis</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=l%C3%BCftungskonzept+filetype%3Apdf"
            target="_blank"
            >Lüftungskonzept</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=architekturplan+filetype%3Apdf"
            target="_blank"
            >Architekturplan</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=konformit%C3%A4tserkl%C3%A4rung+filetype%3Apdf"
            target="_blank"
            >Konformitätserklärung</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=datenblatt+filetype%3Apdf"
            target="_blank"
            >Datenblatt</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=inbetriebnahmeprotokoll+filetype%3Apdf"
            target="_blank"
            >Inbetriebnahmeprotokoll</a
          >
        </li>
        <li>
          <a
            draggable="false"
            href="https://www.google.com/search?q=elektroschema+filetype%3Apdf"
            target="_blank"
            >Elektroschema</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { BuildPDFUpload } from "@/aws";
import DocumentDragAndDrop from "@/components/DocumentDragAndDrop";

export default {
  components: { DocumentDragAndDrop },
  data() {
    return {
      uploadProgress: null
    };
  },
  methods: {
    handleFileUpload(file) {
      const upload = BuildPDFUpload(file);
      upload.on("httpUploadProgress", event => {
        console.log(event);
        this.uploadProgress = (event.loaded / event.total) * 100;
      });
      upload.promise().then(
        // eslint-disable-next-line no-unused-vars
        data => {
          this.$buefy.toast.open({
            message: `${file.name} wurde erfolgreich hochgeladen`,
            type: "is-success"
          });
          this.uploadProgress = null;
        },
        err => console.error(err)
      );
    }
  }
};
</script>

<style></style>
